import { GET_ORG_LICENSE_SETTINGS } from '../../types'
import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getOrgLicenseSettings = () => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/license`, options))

    if (!response.status || response.status === 401 || response.status === 500) {
      log.warn('non 200 status code from licenses')
    } else {
      const { data } = await response.json()
      const orgLicense = {
        beginsAt: data.beginsAt,
        expiresAt: data.expiresAt,
        createdAt: data.createdAt,
        maxUserCount: data.maxUserCount,
        activeUserCount: data.activeUserCount
      }
      dispatch({
        type: GET_ORG_LICENSE_SETTINGS,
        payload: orgLicense
      })
    }
  }
}
